import { render, staticRenderFns } from "./itemEditor.vue?vue&type=template&id=97c1d916&scoped=true&"
import script from "./itemEditor.vue?vue&type=script&lang=js&"
export * from "./itemEditor.vue?vue&type=script&lang=js&"
import style0 from "./itemEditor.vue?vue&type=style&index=0&id=97c1d916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c1d916",
  null
  
)

export default component.exports